import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
@Injectable()
export class QuotationService {

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }
    // service by Bhawna
    //Fetch a single quotation based on id

    getQuotations(id: number): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        params.set('id', typeof id === "number" ? id.toString() : "0");

        let quotationDataSubject = new Subject<any>(); // Will use this subject to emit data that we want

        this.apiRequest.get('api/createQuote/fetchById/' + id)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                quotationDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return quotationDataSubject;
    }

    // Fetch a single quotation container
    getQuotationContainer(id: number): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();

        params.set('id', typeof id === "number" ? id.toString() : "0");

        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('quotationContainer/fetchById/' + id)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;

                returnObj.quotationContainerDO.quotationList.forEach(element => {
                    if(element.exceptionDOList == null)
                    element.exceptionDOList = [];
                });
                
                
                console.log(returnObj);
                quotationDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return quotationDataSubject;
    }

    //save
    saveQuotations(quotationIO): Observable<any> {
        let self = this;
        //let policyIO = policyIO
        let quotationDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save quote attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.post('api/createQuote/save', quotationIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Quote save successful")
                    console.log(jsonResp)
                    // return "Success"
                } else {
                    console.log("Quote save failed")
                    console.log(jsonResp)
                    //return "failed"
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }

    //save quotation Container
    validateComputeQuotationContainer(quotationIO): Observable<any> {
        let self = this;
        //let policyIO = policyIO
        let quotationDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax save quote attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        // this.apiRequest.post('quotationContainer/saveQuoteContainer', quotationIO)
        this.apiRequest.post('quotationContainer/validateComputeQuotationContainer', quotationIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Quote save successful")
                    console.log(jsonResp)
                    // return "Success"
                } else {
                    console.log("Quote save failed")
                    console.log(jsonResp)
                    //return "failed"
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }

    //save quotation Container
    saveQuotationContainer(quotationIO): Observable<any> {
        let self = this;
        //let policyIO = policyIO
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax save quote attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.post('quotationContainer/saveQuoteContainer', quotationIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Quote save successful")
                    console.log(jsonResp)
                    // return "Success"
                } else {
                    console.log("Quote save failed")
                    console.log(jsonResp)
                    //return "failed"
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }

    // get container by search criteria
    searchQuotationContainers(searchParam): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        console.log(searchParam);
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });
        let quotationSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'quotationContainer/searchPortal/' + criteriaArray;
        var returnObj = "success";
        this.apiRequest.get(searchURL)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log("returnObj");
                console.log(returnObj);
                quotationSearchData.next(returnObj);
            });
        return quotationSearchData;
    }

    // get travel container by search criteria
    searchTravelQuotationContainers(searchParam): Observable<any> {
        let me = this;
        let params: URLSearchParams = new URLSearchParams();
        console.log(searchParam);
        var criteriaArray = Object.keys(searchParam).map(function (key) { return searchParam[key]; });
        let quotationSearchData: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax search policy attempt
        let searchURL = 'quotationContainer/searchTravelPortal/' + criteriaArray;
        var returnObj = "success";
        this.apiRequest.get(searchURL)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log("returnObj");
                console.log(returnObj);
                quotationSearchData.next(returnObj);
            });
        return quotationSearchData;
    }

    //generate quotation pdf
    generateQuotationPDF(quotationIO): Observable<any> {
        let self = this;
        //let policyIO = policyIO
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want after ajax save quote attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.post('quotationContainer/generateQuotationLink', quotationIO)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Quote pdf generation successful")
                    console.log(jsonResp)
                    // return "Success"
                } else {
                    console.log("Quote pdf generation failed")
                    console.log(jsonResp)
                    //return "failed"
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }
    //email quotation pdf
    emailQuotationPDF(quotationContainerNum, quotationRefNum): Observable<any> {
        let self = this;
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        // , quotationIO)
        this.apiRequest.get('quotationContainer/emailQuotationPDF/' + quotationContainerNum + ',' + quotationRefNum)
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Quote pdf sent successful")
                    console.log(jsonResp)
                } else {
                    console.log("Quote pdf sent failed")
                    console.log(jsonResp)
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }

    searchGenericQuotation(searchRequestDO, pageNum, pageSize): Observable<any> {
        let self = this;
        //let policyIO = policyIO
        let quotationDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1);// Will use this subject to emit data that we want after ajax save quote attempt
        // let policyInfoReturn:LoginInfoInStorage; // Object that we want to send back to Login Page
        this.apiRequest.post('quotationContainer/searchPortalQuotationsForAgent'+ '?page=' + pageNum + '&size=' + pageSize , searchRequestDO )
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {
                    console.log("Search successful")
                    console.log(JSON.stringify(jsonResp))
                    // return "Success"
                } else {
                    console.log("Search failed")
                    console.log(jsonResp)
                    //return "failed"
                }
                quotationDataSubject.next(jsonResp);

            }, errResp => {
                quotationDataSubject.next(errResp);
            })
        return quotationDataSubject;
    }

}
